module.exports = __webpack_public_path__ + "assets/img/ecg-detail-back-3.370a9dde.png";